import { render, staticRenderFns } from "./b4simple.vue?vue&type=template&id=9f1d854a&scoped=true&"
import script from "./b4simple.vue?vue&type=script&lang=js&"
export * from "./b4simple.vue?vue&type=script&lang=js&"
import style0 from "./b4simple.vue?vue&type=style&index=0&id=9f1d854a&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f1d854a",
  null
  
)

export default component.exports